import React from 'react';
import {
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

const AircraftSelector = ({ aircraft, selectedAircraft, onSelectAircraft }) => {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <FormControl fullWidth>
        <InputLabel>Select Aircraft</InputLabel>
        <Select
          value={selectedAircraft?._id || ''}
          label="Select Aircraft"
          onChange={(e) => {
            const ac = aircraft.find(a => a._id === e.target.value);
            onSelectAircraft(ac);
          }}
        >
          {aircraft.map((ac) => (
            <MenuItem key={ac._id} value={ac._id}>
              {ac.registration} - {ac.manufacturer} {ac.model}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Paper>
  );
};

export default AircraftSelector;

